import { ChangeEvent, KeyboardEvent } from 'react'
import classNames from 'classnames'

import { CHANGE_EDIT_ICON, MAGNIFYING_GLASS, ORANGE_LINE } from 'assets/images'
import SearchInputStyled from './styled'

interface SearchInputProps {
  searchValue: string
  handleSearchValueChanged: (e: ChangeEvent<HTMLInputElement>) => void
  customClass?: string
  placeholder?: string
  onAutoFocus?: boolean
  width?: number
  isPen?: boolean
  onKeyPress?: (e: KeyboardEvent<HTMLInputElement>) => void
}

function SearchInput({
  searchValue,
  handleSearchValueChanged,
  customClass = '',
  placeholder = 'Search',
  onAutoFocus,
  width = 300,
  isPen = false,
  onKeyPress,
}: SearchInputProps) {
  const searchInputClass = classNames('position-relative', 'd-flex', 'align-items-center', customClass)
  const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => onKeyPress?.(e)
  return (
    <SearchInputStyled isPen={isPen} className={searchInputClass} width={width}>
      {!isPen && <img src={ORANGE_LINE} alt='' className='orange-line position-absolute' />}
      {!isPen && <img src={MAGNIFYING_GLASS} alt='search' className='search-icon' />}
      {isPen && <img src={CHANGE_EDIT_ICON} alt='edit' className='pen-icon' width={25} />}
      <input
        autoFocus = {onAutoFocus === true ? true : false}
        type='text'
        className='search-input flex-grow-1'
        placeholder={placeholder}
        value={searchValue}
        onChange={handleSearchValueChanged}
        onKeyPress={handleKeyPress}
      />
    </SearchInputStyled>
  )
}

export default SearchInput
